import React from 'react';
import { siteConfig } from '../data';

export default function Footer() {
  return (
    <footer className="py-12 border-t border-slate-100 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="flex items-center gap-4">
            <img 
              src={siteConfig.logo} 
              alt="Logo" 
              className="w-12 h-12 object-contain"
            />
            <div>
              <p className="text-sm text-slate-900 font-serif mb-1">{siteConfig.name}</p>
              <p className="text-xs text-slate-400">CVR: {siteConfig.contact.cvr}</p>
            </div>
          </div>
          
          <div className="text-xs text-slate-400 space-y-1">
            <p>{siteConfig.contact.address}</p>
            <p>{siteConfig.contact.phone} / {siteConfig.contact.email}</p>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
            &copy; {new Date().getFullYear()} Sandberg Rådgivende Ingeniører ApS
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="https://www.iubenda.com/privacy-policy/94991224" className="iubenda-white iubenda-noiframe iubenda-embed" title="Privatlivspolitik ">Privatlivspolitik</a>
            <a href="https://www.iubenda.com/privacy-policy/94991224/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed" title="Cookiepolitik ">Cookiepolitik</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
